import { type ActivityType, ACTIVITY_TYPE_LABELS } from '@paulownia/shared';

interface ActivityBadgeProps {
  type: ActivityType;
}

/**
 * Badge component displaying a merchant's activity type
 */
export function ActivityBadge({ type }: ActivityBadgeProps) {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
      {ACTIVITY_TYPE_LABELS[type]}
    </span>
  );
}
